import axios from 'axios';

const BASE_URL = process.env.VUE_APP_APIURL;

const ping = () => axios.get(`${BASE_URL}/api/Account/Ping`);
const authorize = (model) => axios.post(`${BASE_URL}/Token`, model, {
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
});
// New OTP verification method
const verifyOTP = (data) => axios.post(`${BASE_URL}/token`, data, {
    headers: { 'Content-Type': 'application/json; charset=utf-8' },
});
const logout = () => axios.post(`${BASE_URL}/api/Account/Logout`);
const changePassword = () => axios.post(`${BASE_URL}/api/Account/ChangePassword`);
const setPassword = () => axios.post(`${BASE_URL}/api/Account/SetPassword`);
const resetUserPassword = (data) => axios.post(`${BASE_URL}/api/Account/ResetUserPassword`, data);
const forgotPassword = (data) => axios.post(`${BASE_URL}/api/Account/ForgotPassword`, data);
const resetPassword = (data) => axios.post(`${BASE_URL}/api/Account/ResetPassword`, data);
const register = (model) => axios.post(`${BASE_URL}/api/Account/Register`, model);
const getLegalStatus = () => axios.get(`${BASE_URL}/api/Account/LegalStatus`);
const acceptLegal = (termsVersion, privacyVersion) => axios.post(`${BASE_URL}/api/Account/LegalAcceptance`, { termsVersion, privacyVersion });

export default {
    ping,
    authorize,
    logout,
    changePassword,
    setPassword,
    resetUserPassword,
    forgotPassword,
    resetPassword,
    register,
    verifyOTP,
    getLegalStatus,
    acceptLegal,
};
